import type { Activity, ActivityFilters } from '@/types/activity';
import type { DownloadQuery } from '@/types/download';

function isOnOrAfter(activityTimestamp: string, from: string): boolean {
  return new Date(activityTimestamp) >= new Date(from);
}

function isOnOrBefore(activityTimestamp: string, to: string): boolean {
  const endOfDay = new Date(to);
  endOfDay.setHours(23, 59, 59, 999);
  return new Date(activityTimestamp) <= endOfDay;
}

export function applyActivityFilters(
  activities: Activity[],
  filters?: ActivityFilters
): Activity[] {
  if (!filters) {
    return activities;
  }

  let filtered = activities;

  const types = filters.types;
  if (types?.length) {
    filtered = filtered.filter((activity) => types.includes(activity.type));
  }

  const vibrationModes = filters.vibrationModes;
  if (vibrationModes?.length) {
    filtered = filtered.filter((activity) =>
      vibrationModes.includes(activity.vibrationMode)
    );
  }

  const startDate = filters.startDate;
  if (startDate) {
    filtered = filtered.filter((activity) =>
      isOnOrAfter(activity.timestamp, startDate)
    );
  }

  const endDate = filters.endDate;
  if (endDate) {
    filtered = filtered.filter((activity) =>
      isOnOrBefore(activity.timestamp, endDate)
    );
  }

  return filtered;
}

export function toActivityFilters(query: DownloadQuery): ActivityFilters {
  return {
    types: query.activityTypes,
    vibrationModes: query.vibrationModes,
    startDate: query.dateRange.from ?? undefined,
    endDate: query.dateRange.to ?? undefined,
  };
}
